import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="115.96298"
        height="27.53002"
        viewBox="0 0 30.681873 7.2839844"
        version="1.1"
        id="svg9538"
      >
        <defs id="defs9532" />
        <g id="layer1" transform="translate(2.73543,-145.05905)">
          <g transform="translate(-315.19945,-330.06261)" id="g9513">
            <path
              id="path9463"
              d="m 320.41514,478.76365 c 0.43397,0.48315 0.67379,1.1077 0.67379,1.75485 0,0.64714 -0.23982,1.27169 -0.67379,1.75485 h -2.87924 c 0.43399,-0.48316 0.67378,-1.10771 0.67378,-1.75485 0,-0.64715 -0.23979,-1.2717 -0.67378,-1.75485 0.43399,-0.48316 0.67378,-1.10771 0.67378,-1.75485 0,-0.64714 -0.23979,-1.2717 -0.67378,-1.75485 h 2.87924 c 0.43397,0.48315 0.67379,1.10771 0.67379,1.75485 0,0.64714 -0.23982,1.27169 -0.67379,1.75485 z"
              fill="#7ff1ab"
              strokeWidth="0.26458332"
            />
            <path
              id="path9465"
              d="m 317.5578,478.76365 c 0.43241,0.48315 0.67136,1.1077 0.67136,1.75485 0,0.64714 -0.23895,1.27169 -0.67136,1.75485 h -4.96149 v -7.0194 h 4.96149 c 0.43241,0.48315 0.67136,1.10771 0.67136,1.75485 0,0.64714 -0.23895,1.27169 -0.67136,1.75485 z"
              fill="#604dad"
              strokeWidth="0.26458332"
            />
          </g>
        </g>
      </svg>
    </>
  ),
  'BibliU',
  '6 0 27 27'
);
